import { render, staticRenderFns } from "./LciQuestions.vue?vue&type=template&id=45e0f2e9&scoped=true&"
import script from "./LciQuestions.vue?vue&type=script&lang=js&"
export * from "./LciQuestions.vue?vue&type=script&lang=js&"
import style0 from "./LciQuestions.vue?vue&type=style&index=0&id=45e0f2e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e0f2e9",
  null
  
)

export default component.exports